export const KOUO_AUTH_LOG_IN = "KOUO_AUTH_LOG_IN";
export const KOUO_AUTH_SIGN_UP = "KOUO_AUTH_SIGN_UP";
export const KOUO_AUTH_UPDATE_USER = "KOUO_AUTH_UPDATE_USER";
export const KOUO_AUTH_FORGOT_PASS = "KOUO_AUTH_FORGOT_PASS";
export const KOUO_AUTH_RESET_PASS = "KOUO_AUTH_RESET_PASS";
export const KOUO_AUTH_LOGOUT_USER = "KOUO_AUTH_LOGOUT_USER";
